(function () {
    'use strict';

    angular
        .module('jotApp')
        .controller('TabUpdateScriptsDialogController', TabUpdateScriptsDialogController);

    TabUpdateScriptsDialogController.$inject = ['$timeout', '$scope', '$stateParams', '$q', 'entity', 'TabUpdateScripts', 'DataUtils', 'TabObjectTypes', '$state','ParseLinks', 'AlertService'];

    function TabUpdateScriptsDialogController($timeout, $scope, $stateParams, $q, entity, TabUpdateScripts, DataUtils, TabObjectTypes, $state,ParseLinks, AlertService) {
        var vm = this;
        vm.tabUpdateScripts = entity;
        vm.tabObjectTypes = [];
        vm.page = 0;
        vm.typeToSearch= '';

        $timeout(function () {
            angular.element('.form-group:eq(0)>input').focus();
        });

        var onSaveSuccess = function (result) {
            $scope.$emit('jotApp:tabUpdateScripts', result);
            vm.isSaving = false;
            $state.go('tab-update-scripts');
        };

        var onSaveError = function (result) {
            vm.isSaving = false;
        };

        vm.save = function () {
            vm.isSaving = true;
            if (vm.tabUpdateScripts.id !== null) {
                TabUpdateScripts.update(vm.tabUpdateScripts, onSaveSuccess, onSaveError);
            } else {
                TabUpdateScripts.save(vm.tabUpdateScripts, onSaveSuccess, onSaveError);
            }
        };

        vm.clear = function () {
            $state.go('tab-update-scripts');
        };

        vm.setScriptContent = function ($file, tabUpdateScripts) {
            if ($file) {
                DataUtils.toBase64($file, function (base64Data) {
                    $scope.$apply(function () {
                        tabUpdateScripts.scriptContent = base64Data;
                    });
                });
            }
        };

        vm.search = function(searchText){
            if(vm.typeToSearch != undefined && vm.typeToSearch != ""){
                vm.typeToSearch = searchText;
                vm.loadAll();
            }
        }

        vm.loadAll = function () {
            TabObjectTypes.query({
                page: vm.page,
                query: vm.typeToSearch,
                size: 20
            }, onSuccess, onError);

            function onSuccess(data, headers) {
                vm.links = ParseLinks.parse(headers('link'));
                vm.totalItems = headers('X-Total-Count');
                for (var i = 0; i < data.length; i++) {
                    vm.tabObjectTypes.push(data[i]);
                }
            }

            function onError(error) {
                AlertService.error(error.data.message);
            }
        };

        vm.loadPage = function (page) {
            if (page <= vm.links['last']) {
                vm.page = page;
                vm.loadAll();
            }
        };

        vm.loadAll();

        vm.openFile = DataUtils.openFile;
        vm.byteSize = DataUtils.byteSize;
    }
})();
